import Icon from '../../shared/components/Icons';
import { SmartImg } from '../../shared/components/Layout';
import { fmtDay } from '../../shared/data/common';

/** Holiday package summary used on review, confirmation and booking details pages. */
export default function PackageSummary({ summary: s }) {
  return (
    <div className="sum">
      <div className="sum-media">
        <div className="sum-thumb"><SmartImg src={s.image} alt={s.title} /></div>
        <div>
          <span className="tag">{s.nights}N / {s.nights + 1}D</span>
          <h3>{s.title}</h3>
          <span className="muted small"><Icon name="pin" size={13} /> {s.cities.join(' → ')}</span>
        </div>
      </div>
      <div className="stay-dates">
        <div><span className="muted small">Departure{s.fromCity ? ` from ${s.fromCity}` : ''}</span><b>{fmtDay(s.date)}</b></div>
        <span className="nights-pill">{s.nights} Nights</span>
        <div><span className="muted small">Return</span><b>{fmtDay(s.returnDate)}</b></div>
      </div>
      <div className="sum-list">
        <span className="muted small">Stay</span>
        <ul>{s.hotels.map((h) => <li key={h}><Icon name="hotels" size={13} /> {h}</li>)}</ul>
      </div>
      <div className="sum-foot">
        <span><Icon name="user" size={14} /> {s.adults} Adult{s.adults > 1 ? 's' : ''}{s.children ? `, ${s.children} Child${s.children > 1 ? 'ren' : ''}` : ''} · {s.rooms} room{s.rooms > 1 ? 's' : ''}</span>
        <span><Icon name="check" size={14} /> {s.includes.join(' · ')}</span>
      </div>
    </div>
  );
}
